import React, { ReactElement } from 'react'
import { graphql } from 'gatsby'
import PageModuleArray from '@system/utils/PageModuleArray'
import { HistoryLocation } from '@reach/router'

export interface GenericPageProps {
  children?: typeof React.Children
  location: HistoryLocation
  pageContext: DBN.PageHelpers.PageContext
  data: {
    contentfulGenericPage: {
      modules: Array<DBN.Contentful.PageModuleUnion>
    }
  }
}

export default function GenericPage({
  data,
  location,
  pageContext,
}: GenericPageProps): ReactElement {
  const modules = data.contentfulGenericPage.modules
  return (
    <>
      {!!modules && (
        <PageModuleArray
          modulearray={modules}
          location={location}
          pageContext={pageContext}
        />
      )}
    </>
  )
}

export const pageQuery = graphql`
  query GenericPageByPath($id: String!, $locale: String!) {
    contentfulGenericPage(id: { eq: $id }, node_locale: { eq: $locale }) {
      modules {
        ...ContentfulModulesFragment
      }
    }
  }
`
